import { formatDateTime, humanize } from '../../lib/format';
import { Order } from '../../types/orders';
import './Orders.css';

const MILESTONES = ['placed', 'dispatched', 'in_transit', 'delivered'];
const LABELS: Record<string, string> = { placed: 'Order placed', returned: 'Returned' };

export default function OrderTimeline({ order }: { order: Order }) {
  const reachedAt = (kind: string) => order.events.find((event) => event.kind === kind);
  // Four milestones always; a fifth node only once the order was returned.
  const nodes = reachedAt('returned') ? [...MILESTONES, 'returned'] : MILESTONES;
  return (
    <>
      <ol className="order-timeline" aria-label="Order progress">
        {nodes.map((kind, index) => {
          const reached = reachedAt(kind);
          const next = nodes[index + 1];
          return (
            <li
              key={kind}
              className={reached ? 'complete' : 'pending'}
              // The line from this node to the next is blue once the next one is reached.
              data-next={next && reachedAt(next) ? 'done' : 'todo'}
            >
              <span className="order-timeline__node" aria-hidden="true" />
              <span className="order-timeline__label">{LABELS[kind] ?? humanize(kind)}</span>
              <small>{reached ? formatDateTime(reached.created_at) : 'Not completed'}</small>
            </li>
          );
        })}
      </ol>
      {order.events
        .filter((event) => !nodes.includes(event.kind))
        .map((event) => (
          <p key={event.id}>
            <strong>{humanize(event.kind)}</strong> · {formatDateTime(event.created_at)} {event.reason}
          </p>
        ))}
    </>
  );
}
